/** The Agio brand logo (brand/agio-logo.svg, served from /brand/). */
import { cn } from '../utils.js';

const SIZES = { sm: 'h-6', md: 'h-8', lg: 'h-14' } as const;

export function AgioLogo({ size = 'md', className }: { size?: keyof typeof SIZES; className?: string }) {
  return <img src="/brand/agio-logo.svg" alt="agio" className={cn(SIZES[size], 'w-auto', className)} />;
}
